import { BGA, DIE, MUX } from "../../../constants/componentType";
import { PKG_TOUCHSTONE, PASSIVE_TOUCHSTONE, PASSIVE_SPICE, TOUCHSTONE, GENERIC_TOUCHSTONE, SPICE } from "../../../constants/libraryConstants";
import { ANDES_V2 } from "../../../constants/pageType";
import designConstructor from "../../helper/designConstructor";
import { getModelFileExist, getPassiveFileExist } from "../../helper/fileExistCheck";
import { SortFn } from "../../helper/sort";
import {
  CAP, CMC, CONNECTOR, DIODE, IC, IGNORE, IND, RES, SERDES_TYPES,
  RLC_TYPES, RLC_TYPES_LIST, checkCompsType, getComponentByName, getComponentNeedInfoByName
} from "../../PCBHelper";
import { CPHY, HDMI, PCIE } from "../../PCBHelper/constants";
import libraryConstructor from "../library/libraryConstructor";
import { getDefaultCompType } from "./channelContentHelper";
import { PACKAGE as PCB_PACKAGE } from '../../../constants/designType';
import _LayoutData from "../../data/LayoutData";
import { channelAdvancedInputList } from "../constants";
import { PRE_LAYOUT } from "../../../constants/designVendor";

const sortTypes = [IC, CONNECTOR, DIE, BGA, CMC, DIODE, CAP, IND, RES, IGNORE]

function getChannelComponents(components, comp_merges) {
  if (!components || !components.length) {
    return [];
  }

  let compList = [], partList = [];
  const pkgTouchstoneList = libraryConstructor.getLibraryValues(PKG_TOUCHSTONE),
    passiveSpiceList = libraryConstructor.getLibraryValues(PASSIVE_SPICE),
    passiveTouchstoneList = libraryConstructor.getLibraryValues(PASSIVE_TOUCHSTONE),
    genericSpiceList = libraryConstructor.getLibraryValues(SPICE),
    genericTouchstoneList = libraryConstructor.getLibraryValues(GENERIC_TOUCHSTONE);

  function getChannelComponentsElement(comp) {
    const { part, type, name, pins, model, pinsConnection, layer, isMergeComp, isCopyComp, dieModel } = comp;
    const existInfo = {};
    existInfo.passiveFileNotExist = pkgTouchstoneList && ["touchstone", "spice"].includes(model.type) ? getPassiveFileExist(model, { passiveSpiceList, passiveTouchstoneList }) : null;
    existInfo.cmcFileNotExist = [CMC, MUX].includes(type) && model && model.files ? getModelFileExist({ ...model, type: TOUCHSTONE }, { touchstoneList: type === MUX ? genericTouchstoneList : passiveTouchstoneList }) : null;
    existInfo.diodeFileNotExist = type === DIODE && model && model.id ? diodeModelCheck(model, passiveTouchstoneList) : null;
    existInfo.genericFileNotExist = type === DIE && dieModel && dieModel.files ? getModelFileExist(dieModel, { touchstoneList: genericTouchstoneList, spiceList: genericSpiceList }) : null;
    return {
      part,
      comps: [{ name, pins, type }],
      type,
      model,
      cmcModel: model,
      pinsConnection,
      diodeModel: model,
      layer,
      isMergeComp,
      isCopyComp,
      dieModel,
      ...existInfo
    }
  }

  const filterComps = filterTestPoint(components, comp_merges);
  for (const comp of filterComps) {
    const { part, type, name, pins } = comp;
    if (partList.includes(part)) {
      //according to type and part separate comp.
      const _findIndex = compList.findIndex(item => item.part === part && item.type === type && ![...SERDES_TYPES/* , CMC, DIODE */].includes(type));
      if (_findIndex > -1) {
        compList[_findIndex].comps.push({ name, pins, type });
      } else {
        const comElement = getChannelComponentsElement(comp);
        compList.push(comElement);
      }
    } else {
      partList.push(part);
      const comElement = getChannelComponentsElement(comp);
      compList.push(comElement);
    }
  }

  compList = SortFn(compList, sortTypes, 'type');
  return compList;
}

function diodeModelCheck(library, touchstoneList) {
  if (touchstoneList.find(item => item.id === library.id)) {
    return false;
  } else if (touchstoneList.find(item => item.name === library.name)) {
    return { updateText: library.name };
  }
  return { deleteText: library.name };

}

function getSignalPinColumns(components, serdesType, comp_merges = []) {
  let ICComps = components.filter(item => SERDES_TYPES.includes(item.type));

  const filterComps = filterTestPoint(ICComps, comp_merges);
  // sort component
  ICComps = SortFn(filterComps, SERDES_TYPES, 'type');
  const isFixed = ICComps.length > 5 ? "left" : null;
  const group = {
    title: 'Group',
    dataIndex: 'group',
    key: 'group',
    width: isFixed ? 100 : "10%",
    fixed: isFixed
  };
  let signalPinsColumns = [];
  if (![HDMI, CPHY].includes(serdesType)) {
    signalPinsColumns.push(group)
  }
  signalPinsColumns = [
    ...signalPinsColumns,
    {
      title: 'checkBox',
      dataIndex: 'check',
      key: 'check',
      width: 42,
      fixed: isFixed
    }, {
      title: 'Signal',
      dataIndex: 'signal',
      key: 'signal',
      width: isFixed ? 180 : (ICComps.length ? "22%" : "30%"),
      fixed: isFixed
    }, {
      title: 'Differential Nets',
      dataIndex: 'nets',
      key: 'nets',
      width: isFixed ? 210 : (ICComps.length ? "28%" : "50%"),
      fixed: isFixed
    }];

  for (const comp of ICComps) {
    const title = getCompNames(comp, ICComps, "string");
    signalPinsColumns.push({
      title,
      dataIndex: `component_${comp.name}`,
      key: comp.name
    })
  }
  return signalPinsColumns;
}

function splitSignalsByGroup(signals) {
  let groupSignals = [];
  for (const sig of signals) {
    const index = groupSignals.findIndex(it => it.group === sig.group);
    if (index > -1) {
      groupSignals[index].signals.push(sig);
      continue;
    }

    groupSignals.push({
      group: sig.group,
      signals: [sig]
    })
  }

  return groupSignals;
}

function getSignalPinsData(components, signals, selectedSignals = [], serdesType) {
  if (!components || !signals) {
    return [];
  }
  //get ic component pins [ {pin, net, usage, model, component }]
  //  const ICCompPins = getICCompPins(components);
  const ICCompPins = components.filter(item => SERDES_TYPES.includes(item.type));
  //split signals by group
  const groupSignals = splitSignalsByGroup(signals);
  //get signal pins data list
  let signalPins = [];
  for (let index = 0; index < groupSignals.length; index++) {
    const item = groupSignals[index];
    const _itemPins = getSignalPinsList(ICCompPins, item.signals, item.group, index, selectedSignals, serdesType);
    signalPins = [...signalPins, ..._itemPins]
  }

  return signalPins;
}

function getSignalPinsList(ICCompPins, signals, group, index, selectedSignals, serdesType) {
  let signalPins = [];
  for (let sig of signals) {

    if (serdesType === CPHY) {
      const { a_pin, b_pin, c_pin } = getPinByCompNets({ ICCompPins, A_Nets: sig.nets_A, B_Nets: sig.nets_B, C_Nets: sig.nets_C, serdesType });
      signalPins.push({
        signal: sig.name,
        signalDisplay: true,
        nets: [...(sig.nets_A || [])],
        netPlaceHolder: "Line A Nets",
        netType: "Line A",
        groupLength: 0,
        groupIndex: index,
        checked: selectedSignals.includes(sig.name),
        ...a_pin
      });
      signalPins.push({
        signal: sig.name,
        signalDisplay: false,
        nets: [...(sig.nets_B || [])],
        netPlaceHolder: "Line B Nets",
        netType: "Line B",
        groupLength: 0,
        groupIndex: index,
        checked: selectedSignals.includes(sig.name),
        ...b_pin
      });
      signalPins.push({
        signal: sig.name,
        signalDisplay: false,
        nets: [...(sig.nets_C || [])],
        netPlaceHolder: "Line C Nets",
        netType: "Line C",
        groupLength: 0,
        groupIndex: index,
        checked: selectedSignals.includes(sig.name),
        ...c_pin
      });
      continue;
    }

    const { p_pin, n_pin } = getPinByCompNets({ ICCompPins, P_Nets: sig.nets_P, N_Nets: sig.nets_N });
    //add p net
    signalPins.push({
      signal: sig.name,
      signalDisplay: true,
      nets: [...sig.nets_P],
      netPlaceHolder: "Positive Nets",
      netType: "positive",
      groupLength: 0,
      groupIndex: index,
      checked: selectedSignals.includes(sig.name),
      ...p_pin
    });

    //add n net
    signalPins.push({
      signal: sig.name,
      signalDisplay: false,
      nets: [...sig.nets_N],
      netType: "negative",
      netPlaceHolder: "Negative Nets",
      groupLength: 0,
      groupIndex: index,
      ...n_pin
    });
  }
  if (signalPins[0]) {
    signalPins[0].groupLength = signalPins.length;
    signalPins[0].group = group;
  }
  return signalPins;
}

function getPinByCompNets({ ICCompPins, P_Nets = [], N_Nets = [], A_Nets = [], B_Nets = [], C_Nets = [], serdesType }) {
  let p_pin = {}, n_pin = {}, a_pin = {}, b_pin = {}, c_pin = {};

  ICCompPins.forEach(comp => {
    for (let item of comp.pins) {
      if (serdesType === CPHY) {
        if (A_Nets.includes(item.net) && !a_pin[`component_${comp.name}`]) {
          a_pin[`component_${comp.name}`] = { ...item, component: comp.name };
        }
        if (B_Nets.includes(item.net) && !b_pin[`component_${comp.name}`]) {
          b_pin[`component_${comp.name}`] = { ...item, component: comp.name };
        }
        if (C_Nets.includes(item.net) && !c_pin[`component_${comp.name}`]) {
          c_pin[`component_${comp.name}`] = { ...item, component: comp.name };
        }

        if (a_pin[`component_${comp.name}`] && b_pin[`component_${comp.name}`] && c_pin[`component_${comp.name}`]) {
          break;
        }

      } else {
        if (P_Nets.includes(item.net) && !p_pin[`component_${comp.name}`]) {
          p_pin[`component_${comp.name}`] = { ...item, component: comp.name };
        }

        if (N_Nets.includes(item.net) && !n_pin[`component_${comp.name}`]) {
          n_pin[`component_${comp.name}`] = { ...item, component: comp.name };
        }

        if (p_pin[`component_${comp.name}`] && n_pin[`component_${comp.name}`]) {
          break;
        }
      }
    }
  })
  return { p_pin, n_pin, a_pin, b_pin, c_pin }
}

function getSignalCheckedStatus(selectedSignals, signals, group) {
  let checked = false, indeterminate = false;

  if (selectedSignals.length === 0) {
    return { checked, indeterminate };
  }

  if (group) {
    const groupSignals = signals.filter(item => item.group === group);
    const notSelectedGroupSignals = groupSignals.filter(item => !selectedSignals.includes(item.name));
    if (notSelectedGroupSignals.length === 0) {
      checked = true;
      indeterminate = false;
    } else if (notSelectedGroupSignals.length < groupSignals.length) {
      checked = false;
      indeterminate = true;
    } else {
      checked = false;
      indeterminate = false;
    }
    return { checked, indeterminate };
  }

  if (signals.length === selectedSignals.length) {
    checked = true;
    indeterminate = false;
  } else {
    checked = false;
    indeterminate = true;
  }
  return { checked, indeterminate };
}

function getRowClassName(record, index, serdesType) {
  let className = "editable-row";

  if (record.groupIndex % 2 === 0 && ![HDMI, CPHY].includes(serdesType)) {
    className = className + " aurora-signal-background";
  }

  if (serdesType !== CPHY && index % 2 !== 0) {
    className = className + " aurora-record-background";
  }

  if (serdesType === CPHY && index % 3 === 1) {
    className = className + " aurora-record-background";
  }

  return className;
}

function getCompUsageList({ type, record, designId, serdesType, designVendor }) {
  const comp = record.comps.length && record.comps[0] ? record.comps[0] : null;
  const designType = designConstructor.getDesign(designId).type;

  if (record.isMergeComp || record.isCopyComp) {
    return [IC, CONNECTOR, IGNORE].map(item => { return { key: item, value: item } });
  }

  let options = [];
  switch (type) {
    case IC:
    case CONNECTOR:
    case BGA:
    case DIE:
      const pcbComp = getComponentByName(designId, comp.name);

      if ([BGA, DIE].includes(type)) {
        options.push(...[BGA, DIE].map(item => { return { key: item, value: item } }));
      } else {
        options.push(...[IC, CONNECTOR].map(item => { return { key: item, value: item } }));
      }

      const _compPinList = pcbComp && pcbComp.mPart ? pcbComp.mPart.mPinList || [] : [];
      let compType = '';
      if (designType === PCB_PACKAGE) {
        compType = getDefaultCompType(comp.name, type, [], designType);
      } else {
        compType = checkCompsType(comp.name, null, _compPinList.length, record.part, ANDES_V2);
      }
      if (compType === DIODE && designVendor !== PRE_LAYOUT) {
        options.push({ key: DIODE, value: DIODE });
      }

      if (pcbComp && pcbComp.mPart.mPinList && pcbComp.mPart.mPinList.length === 4 && serdesType !== PCIE /* && ![BGA, DIE].includes(type) */) {
        options.push({ key: CMC, value: CMC });
      }

      if (pcbComp && pcbComp.mPart.mPinList && pcbComp.mPart.mPinList.length >= 4 && serdesType !== PCIE) {
        options.push({ key: MUX, value: MUX });
      }
      break;
    case CMC:
    case MUX:
      const icTypes = designType === PCB_PACKAGE ? [DIE, BGA] : [IC, CONNECTOR];
      options.push(...icTypes.map(item => { return { key: item, value: item } }));
      options.push({ key: type, value: type });
      break;
    case RES:
    case IND:
    case CAP:
      options.push(...RLC_TYPES_LIST);
      break;
    case DIODE:
      options.push({ key: DIODE, value: DIODE });
      break;
    case IGNORE:
      const _pcbComp = getComponentByName(designId, comp.name);
      const compPinList = _pcbComp && _pcbComp.mPart ? _pcbComp.mPart.mPinList || [] : [];
      let _type = IGNORE;
      if (designType === PCB_PACKAGE) {
        _type = getDefaultCompType(comp.name, type, [], designType);
        options.push(...[BGA, DIE].map(item => { return { key: item, value: item } }));
      } else {
        _type = checkCompsType(comp.name, null, compPinList.length, record.part, ANDES_V2);
        options.push(...[IC, CONNECTOR].map(item => { return { key: item, value: item } }));
      }
      if (RLC_TYPES.includes(_type)) {
        options = [...RLC_TYPES_LIST];
        break;
      }
      if (_type === DIODE) {
        options.push({ key: DIODE, value: DIODE });
        break;
      }

      if (compPinList.length === 4 && serdesType !== PCIE/*  && designType !== PCB_PACKAGE */) {
        options.push({ key: CMC, value: CMC });
      }

      if (compPinList.length >= 4 && serdesType !== PCIE/*  && designType !== PCB_PACKAGE */) {
        options.push({ key: MUX, value: MUX });
      }
      break;
    default: break;
  }

  if (!options.find(item => item.key === DIODE) && designVendor !== PRE_LAYOUT) {
    options.push({ key: DIODE, value: DIODE });
  }
  options.push({ key: IGNORE, value: IGNORE });
  return options;
}

function getSetupComponentInfo({ channelDesignId, components, signals }) {
  if (!components || !signals || !components.length) {
    return {}
  }
  let compsInfo = {};
  const ICComps = components.filter(item => SERDES_TYPES.includes(item.type));

  /*  const signalNets = signals.map(item => { return [...item.nets_P, ...item.nets_N] }).flat(2) */
  for (let comp of ICComps) {
    compsInfo[comp.name] = {};
    const { pinList } = getComponentNeedInfoByName({ designID: channelDesignId, compName: comp.name });

    const CompPinsNets = _LayoutData.getCompPinsNets(channelDesignId);
    const compPinsInfo = CompPinsNets[comp.name] || {};//{[pin]:{mName:net name, ... }}
    for (let pin of pinList || []) {
      const pinNet = (compPinsInfo[pin.mNumber] || {}).mName;
      /*  if (signalNets.includes(pinNet)) { */
      compsInfo[comp.name][pin.mNumber] = pinNet;
      /*  } */
    }
  }
  return compsInfo;
}

function getICCompNetPins({ compName, record, compsInfo, comp_merges }) {
  const findPin = record[`component_${compName}`] || {};
  const nets = record.nets || [];
  const mergeComp = comp_merges.find(item => item.merged_name === compName);

  let pinNets = []
  if (mergeComp) {
    for (const tp of mergeComp.components) {
      const allPins = compsInfo[tp] || {};
      pinNets = [...pinNets, ...Object.keys(allPins).map(item => ({ pin: tp, net: allPins[item] }))];
    }
  } else {
    const allPins = compsInfo[compName] || {};
    pinNets = Object.keys(allPins).map(item => ({ pin: item, net: allPins[item] }));
  }

  const pins = pinNets.filter(item => nets.includes(item.net))
  return {
    pins,
    selectedPin: findPin
  }
}

function getAdvancedInputListByserdesType(serdesType) {
  if (serdesType === CPHY) {
    return channelAdvancedInputList.filter(item => ['netNamePrefix', 'ALineFlags', 'BLineFlags', 'CLineFlags'].includes(item.key))
  }
  return channelAdvancedInputList.filter(item => !['ALineFlags', 'BLineFlags', 'CLineFlags'].includes(item.key));
}

/**
 * Filter out the useless test point data and unused pins in the component
 * @param {Array} components 
 * @param {Array} comp_merges 
 * @returns 
 */
function filterTestPoint(components = [], comp_merges = []) {
  // filter test point
  const testPointComps = comp_merges.map(item => item.components).flat();
  // .map(it => it), Prevent modification of data from the original components
  const filterComps = [...components].filter(item => !testPointComps.includes(item.name));
  // .map(it => JSON.parse(JSON.stringify(it)));
  filterComps.forEach((comp) => {
    // Filters unused pins
    comp.pins = comp.pins.filter(pin => !!pin.signal && !!pin.net);
  })

  return filterComps;
}

/**
 * Get the text display of comp_merge
 * @param {Object} record {comps: [{name}], isMergeComp, isCopyComp, layer}
 * @param {Array} components 
 * @param {string} resType "array" | "string"
 * @returns {string | Array}
 */
function getCompNames(record, components = [], resType) {
  const { comps, isMergeComp, isCopyComp, name } = record;
  let names = comps ? comps.map(item => item.name) : [name];
  if (isMergeComp || isCopyComp) {
    const compName = comps ? comps[0].name : name;
    const compInfo = components.find(item => item.name === compName) || {};
    names = (compInfo.pins || []).map(item => item.pin);
  }

  if (resType === "string") {
    return `${names.join(', ')} ${record.isMergeComp || record.isCopyComp ? "(" + record.layer + ")" : ""}`
  }
  return names;
}

export {
  getChannelComponents,
  getSignalPinColumns,
  getSignalPinsData,
  getSignalCheckedStatus,
  getRowClassName,
  getCompUsageList,
  splitSignalsByGroup,
  getICCompNetPins,
  getSetupComponentInfo,
  getAdvancedInputListByserdesType,
  filterTestPoint,
  getCompNames
}